export default __webpack_public_path__ + "static/media/Monk's Arm-straps of the Underworld.cc00703b.jpg";